import { useRef } from 'react';
import PropTypes from 'prop-types';

import { noOp } from '../../../../utils/util';

import './checkbox.scss';

const Checkbox = ({ className, name, value, onChange }) => {
  const ref = useRef(undefined);

  return (
    <div
      className={`checkbox ${className}`}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          ref.current.click();
        }
      }}
      data-testid="checkbox"
    >
      <input id={name} type="checkbox" name={name} onChange={onChange} ref={ref} />

      <svg aria-hidden="true" viewBox="0 0 16 16" fill="none">
        <path d="M1 4.5L5 9L14 1" stroke={value ? 'black' : 'none'} />
      </svg>
    </div>
  );
};

Checkbox.propTypes = {
  name: PropTypes.string,
  value: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func,
};

Checkbox.defaultProps = {
  name: undefined,
  value: false,
  className: '',
  onChange: noOp,
};

export default Checkbox;
